import { cn } from '@/utils/classname';
import { Skeleton } from '@skand/ui';

export const Loader = () => {
  return (
    <div
      className={cn(
        'flex',
        'mt-3',
        'flex-col',
        'h-50 p-3',
        'gap-4',
        'border-solid border-1 border-neutral-300 rounded-md',
      )}
    >
      <span className={cn('color-neutral-800', 'typo-text-m-em')}>Calculating...</span>
      <div className="flex flex-row justify-between">
        <Skeleton className="h-[10px] w-25" />
        <Skeleton className="h-[10px] w-[36px]" />
      </div>
      <div className="flex flex-row justify-between">
        <Skeleton className="h-[10px] w-[78px]" />
        <Skeleton className="h-[10px] w-[36px]" />
      </div>
      <div className="flex flex-row justify-between">
        <Skeleton className="h-[10px] w-[67px]" />
        <Skeleton className="h-[10px] w-[36px]" />
      </div>
      <div className="flex flex-row justify-between">
        <Skeleton className="h-[10px] w-[55px]" />
        <Skeleton className="h-[10px] w-[36px]" />
      </div>
      <div className="flex flex-row justify-between">
        <Skeleton className="h-[10px] w-[125px]" />
        <Skeleton className="h-[10px] w-[36px]" />
      </div>
      <div className="flex flex-row justify-between">
        <Skeleton className="h-[10px] w-[35px]" />
        <Skeleton className="h-[10px] w-[36px]" />
      </div>
    </div>
  );
};
